import { DarkMode, LightMode } from '@chakra-ui/react'

export type ColorModeProps = {
  colorMode?: 'light' | 'dark'
  children?: React.ReactNode
}

export const ColorMode = ({ children, colorMode }: ColorModeProps) => {
  if (colorMode === 'dark') {
    return <DarkMode>{children}</DarkMode>
  }

  if (colorMode === 'light') {
    return <LightMode>{children}</LightMode>
  }

  return children
}
